import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { FaRobot } from "react-icons/fa";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <div className="flex justify-between items-center h-24 w-full px-6 sm:px-8 lg:px-12 text-white bg-gray-900 sticky top-0 z-50">
      {/* Logo/Title that links back to home */}
      <Link 
        to="/" 
        className="flex items-center min-w-[180px] hover:opacity-80 transition-opacity"
      >
        <FaRobot className="text-[#00df9a] mr-3 text-2xl lg:text-3xl" />
        <h1 className="text-2xl sm:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#00df9a] to-blue-400">
          PRIOR TESTNET
        </h1>
      </Link>

      {/* Desktop Navigation - Now aligned to the right */}
      <div className="hidden md:flex flex-1 justify-end">
        <ul className="flex items-center space-x-2 lg:space-x-4">
          <li className="px-4 py-3 rounded-lg hover:bg-gray-800 transition-all duration-200">
            <Link to="/" className="block w-full h-full">Home</Link>
          </li>
          <li className="px-4 py-3 rounded-lg hover:bg-gray-800 transition-all duration-200">
            <Link to="/faucet" className="block w-full h-full">Faucet</Link>
          </li>
          <li className="px-4 py-3 rounded-lg hover:bg-gray-800 transition-all duration-200">
            <Link to="/swap" className="block w-full h-full">Swap</Link>
          </li>
          <li className="px-4 py-3 rounded-lg hover:bg-gray-800 transition-all duration-200">
            <Link to="/quest" className="block w-full h-full">Quest</Link>
          </li>
        </ul>
      </div>

      {/* Mobile Menu Icon - Properly spaced to the right */}
      <div 
        onClick={handleNav} 
        className="block md:hidden cursor-pointer p-3 -mr-2"
        aria-label="Toggle menu"
      >
        {nav ? (
          <AiOutlineClose size={24} className="text-[#00df9a]" />
        ) : (
          <AiOutlineMenu size={24} className="text-[#00df9a]" />
        )}
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={
          nav
            ? "fixed inset-0 w-full h-screen bg-black bg-opacity-70 backdrop-blur-sm z-40 transition-opacity duration-300"
            : "hidden"
        }
        onClick={handleNav}
      ></div>

      {/* Mobile Menu Sidebar */}
      <div
        className={
          nav
            ? "fixed right-0 top-0 w-64 h-full bg-gray-900 border-l border-gray-800 shadow-2xl z-50 ease-in-out duration-300"
            : "fixed right-[-100%] top-0 ease-in-out duration-300"
        }
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-800">
          <Link to="/" onClick={handleNav} className="flex items-center">
            <FaRobot className="text-[#00df9a] mr-3 text-2xl" />
            <span className="text-xl font-bold text-[#00df9a]">PRIOR TESTNET</span>
          </Link>
          <button 
            onClick={handleNav}
            className="p-1 rounded-full hover:bg-gray-800 transition"
          >
            <AiOutlineClose size={20} className="text-[#00df9a]" />
          </button>
        </div>
        
        <ul className="p-4 flex flex-col space-y-2">
          <li onClick={handleNav}>
            <Link 
              to="/" 
              className="block px-4 py-3 rounded-lg hover:bg-gray-800 transition text-gray-300 hover:text-white"
            >
              Home
            </Link>
          </li>
          <li onClick={handleNav}>
            <Link 
              to="/faucet" 
              className="block px-4 py-3 rounded-lg hover:bg-gray-800 transition text-gray-300 hover:text-white"
            >
              Faucet
            </Link>
          </li>
          <li onClick={handleNav}>
            <Link 
              to="/swap" 
              className="block px-4 py-3 rounded-lg hover:bg-gray-800 transition text-gray-300 hover:text-white"
            >
              Swap
            </Link>
          </li>
          <li onClick={handleNav}>
            <Link 
              to="/quest" 
              className="block px-4 py-3 rounded-lg hover:bg-gray-800 transition text-gray-300 hover:text-white"
            >
              Quest
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;